import { IUserSessionBase, IUserSessionLive, UserSessionState } from './user-session.model';

export class UserSessionMapper {
  public isSelected(item: IUserSessionBase): boolean {
    return item.state === UserSessionState.Selected;
  }

  public isInAcw(item: IUserSessionBase): boolean {
    return [UserSessionState.InAfterCallWork, UserSessionState.InExtendedAfterCallWork].includes(item.state);
  }

  public isCompleted(item: IUserSessionBase): boolean {
    return item.state === UserSessionState.Terminated;
  }

  public preserveClientState(item: IUserSessionLive, previousItem?: IUserSessionLive): IUserSessionLive {
    return {
      ...item,
      imHasNewMessages: item.imHasNewMessages ?? previousItem?.imHasNewMessages,
    };
  }
}
